<template>
  <div class="kye-upload-list">
    <div class="kye-upload-list_item" v-for="(file, index) in files" :key="index" @click="previewFile(index)">
      <div class="file-info">
        <img :src="getImgSuffix(file)" alt="" />
        <p class="kye-upload-file-name" :title="file.name">{{ file.name }}</p>
      </div>

      <div class="kye-upload-list_right">
        <div class="kye-upload-close kye-upload-dowload" v-if="!disabled">
          <img src="./images/download-icon.png" @click.stop="$emit('download', file)" alt="" />
        </div>
        <div class="kye-upload-close" v-if="!disabled">
          <img src="./images/close.png" @click.stop="deleteFile(index)" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getImgSuffix } from './utils'
function getFileName(name) {
  return (name && name.substring(name.lastIndexOf('.') + 1).toLowerCase()) || ''
}

export default {
  props: {
    files: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  methods: {
    getImgSuffix(file) {
      const imgType = file.extendName || getFileName(file.name)
      return getImgSuffix(imgType)
    },
    deleteFile(index) {
      this.$emit('deleteFile', index)
    },
    previewFile(index) {
      this.$emit('previewFile', this.files, index)
    }
  }
}
</script>

<style lang="scss">
.kye-upload {
  &-list {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 16px;
    border: 1px solid #e6e7ea;
    margin-left: 12px;
    border-radius: 4px;
    align-content: flex-start;
    &_right {
      display: flex;
      align-items: center;
    }
    &_item {
      width: 180px;
      padding: 5px 8px;
      background: #f7f8fa;
      height: 28px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      cursor: pointer;
      .file-info {
        display: flex;
        align-items: center;
        flex: 1;
      }
      img {
        width: 12px;
        height: 12px;
        margin-right: 5px;
      }
    }
  }

  &-file-name {
    width: 100px;
    font-size: var(--g-default-font-size);
    color: var(--g-color-primary);
    flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &-close {
    display: flex;
    align-items: center;
    width: 12px;
    height: 12px;
    img {
      width: 100%;
      height: 100%;
      cursor: pointer;
    }
  }

  &-dowload {
    width: 10px;
    height: 10px;
    margin-right: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/components/kye-upload/file-list.vue